import type { TranslationModule } from '../types';

export const quickServicesTranslations: TranslationModule = {
  ro: {
    sectionTitle: "SERVICII RAPIDE",
    badgeNew: "NOU",
    sectionDesc: "Accesează rapid cele mai solicitate servicii juridice.",
    firmaTitle: "Înființare Firmă",
    firmaDesc: "Ghid pas cu pas pentru înregistrarea unei societăți.",
    extrasTitle: "Cerere Extras Carte Funciară",
    extrasDesc: "Obține rapid extrasul de carte funciară online.",
    avocatTitle: "Contactează Avocat Specializat",
    avocatDesc: "Consultă un avocat în domeniul tău de interes."
  },
  en: {
    sectionTitle: "QUICK SERVICES",
    badgeNew: "NEW",
    sectionDesc: "Quickly access the most requested legal services.",
    firmaTitle: "Company Incorporation",
    firmaDesc: "Step-by-step guide for registering a company.",
    extrasTitle: "Request Land Registry Extract",
    extrasDesc: "Quickly obtain a land registry extract online.",
    avocatTitle: "Contact Specialized Lawyer",
    avocatDesc: "Consult a lawyer in your area of interest."
  },
  fr: {
    sectionTitle: "SERVICES RAPIDES",
    badgeNew: "NOUVEAU",
    sectionDesc: "Accédez rapidement aux services juridiques les plus demandés.",
    firmaTitle: "Création d'Entreprise",
    firmaDesc: "Guide étape par étape pour enregistrer une société.",
    extrasTitle: "Demander Extrait du Registre Foncier",
    extrasDesc: "Obtenez rapidement un extrait de registre foncier en ligne.",
    avocatTitle: "Contacter un Avocat Spécialisé",
    avocatDesc: "Consultez un avocat dans votre domaine d'intérêt."
  }
};

export default quickServicesTranslations;
